import { Component } from "../../core/Component";
// import * as $ from "../../core/utils";

export class TextareaComponent extends Component {
  // static className = "qform-row";
  constructor($root, options) {
    super($root, options);
    /* if (options.fieldAlign) {
      $root.$el.classList.add(`fieldAlign-${options.fieldAlign}`);
    }
    if (options.formStyle.labelsPosition && options.formStyle.labelsPosition !== false) {
      $root.$el.classList.add(
        `labelsPosition-${options.formStyle.labelsPosition}`
      );
    } */
    /* if(typeof options.classes === "string" && options.classes.length > 0) {
      $root.$el.classList.add(`wrap-${options.classes}`)
    } */
    this.maxLength = 3584;
    this.messages = options.messages;
    this.fieldId = options.id;
    this.typeId = options.typeId;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "text";
    this.require = options.required === 1;
    this.placeholder = options.placeholder || "";
    this.classes = options.classes || "";
    this.useDesign = options.useDesign;
    // установка пользовательских классов оформления
    // this.setUserClasses()
    this.wrapClasses = this.makeWrapUserClasses();
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formIndex}`; //${options.formId}_${options.formIndex}_${options.name}
    this.boxId = `${options.name}_${options.formIndex}_box`;
    this.boxIdField = `${options.name}_${options.formIndex}_box-field`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text`;
    this.labelId = `${options.name}_${options.formIndex}_label`;
    this.saveInStorage = options.data.saveInStorage;
  }
  toHTML() {
    return `
    <div class="qform-field textarea ${this.hint ? 'qform-hint' : ''} ${this.wrapClasses?.join(' ') || ''}" id="${this.boxId}">
      <div class="qform-field_wrap">
      ${this.toHtmlOutLabelBox()}
      <div class="qform-field__block">
        ${this.toHtmlAttBox('out_left')}
          <div class="qform-field__block_box">
            <div class="qform-field__block_box__field" id="${this.boxIdField}">
              ${this.toHtmlAttBox('in_left')}
              <div class="qform-field__block_box__field-box">
                <textarea
                  class="qform-field__block_box__field-box_input ${this.classes}"
                  id="${this.id}"
                  name="${this.name}"
                  placeholder="${this.placeholder.replace(/"/g, '&quot;')}"
                >
                </textarea>
                ${this.useDesign ? `<label for="${this.id}" class="qform-field__block_box__field-box_label">${this.label}</label>` : ''}
              </div>
              ${this.toHtmlAttBox('in_right')}
            </div>
          </div>
          ${this.toHtmlAttBox('out_right')}
        </div>
      </div>
      ${this.toHtmlBottomBox()}
    </div>
    `;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$input.disabled = disable;
    this.$boxField = this.$root.$el.querySelector(`#${this.boxIdField}`);
    this.$input.value = "";
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$label = this.$root.$el.querySelector(`#${this.labelId}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    this.listeners = [];
    if (this.$input && !disable) {
      this.listeners = [{
        eventName: "input",
        method: "onInput",
        el: this.$input
      }, {
        eventName: "change",
        method: "onChange",
        el: this.$input
      }, {
        eventName: "focus",
        method: "onFocus",
        el: this.$input
      }, {
        eventName: "blur",
        method: "onBlur",
        el: this.$input
      }];
    }
    setTimeout(() => {
      const storedData = JSON.parse(localStorage.getItem(this.options.formId));
      if (storedData && storedData[this.name]) {
        this.$input.value = storedData[this.name];
        this.$emit("Change:field", {});
      }
    }, 200);
    super.init();
  }
  onInput(event) {
    event.preventDefault();
    this.validation();
    this.$emit("Change:field", {});
  }
  onChange(event) {
    if (this.saveInStorage) {
      let storage = JSON.parse(localStorage.getItem(this.options.formId));
      if (storage) {
        storage[this.$input.name] = this.$input.value;
      }
      localStorage.setItem(this.options.formId, JSON.stringify(storage));
    }
    this.$emit("Change:field", {});
  }
  onFocus(event) {
    this.$boxField.classList.add('qform-field-focus');
  }
  onBlur(event) {
    this.$boxField.classList.remove('qform-field-focus');
  }
  getValue() {
    let values = [];
    if (this.$input.value.trim().length > 0) {
      values.push(this.$input.value.trim());
    }
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: values
    };
  }
  setClassField(data) {
    if (data && typeof data.formStyleFieldRequired !== 'undefined') {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add('required');
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add('not-required');
      }
    }
  }
  validation() {
    let setMessageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    if (this.require && this.$input.value.trim().length === 0) {
      setMessageValid ? this.setMessageValid(this.messages.inputRequired) : null;
      valid = false;
      //ограничение на java - 3584 для текстовых полей
    } else if (this.$input.value.trim().length > 3584) {
      valid = false;
      setMessageValid ? this.setMessageValid(this.messages.inputTextTooLong) : null;
    } else {
      this.setMessageValid();
    }
    this.setSuccessValid(valid);
    return valid;
  }
}